import { ReactElement, ReactNode, useState } from 'react'
import { InformationPopover } from 'components/Checkout/AttendeesForm/InformationPopover'
import { ButtonVariant } from 'components/common/Button/ButtonVariant'
import {
  DesktopContainer,
  MobileContainer
} from 'components/common/common.style'
import {
  IconContainerEnd,
  IconContainerStart,
  PopoverContainer,
  StyledButton
} from './Button.style'

export interface ButtonProps
  extends Omit<
    React.ComponentPropsWithoutRef<'button'>,
    'popover' | 'children'
  > {
  variant?: ButtonVariant
  label?: string | ReactNode
  fullWidth?: boolean
  fullWidthOnMobile?: boolean
  leftIcon?: ReactElement<any, any>
  icon?: ReactElement<any, any>
  largeIcon?: boolean
  rightIcon?: ReactElement<any, any>
  shrinkOnMobile?: boolean
  noBorder?: boolean
  noBackground?: boolean
  height?: number
  padding?: number
  popover?: { label: string }
  size?: 'small' | 'medium'
  ellipsis?: boolean
}

export const Button = ({
  variant,
  label,
  fullWidth,
  fullWidthOnMobile,
  leftIcon,
  icon,
  largeIcon,
  rightIcon,
  shrinkOnMobile,
  noBorder,
  noBackground,
  height,
  padding,
  popover,
  disabled,
  size,
  ellipsis,
  ...rest
}: ButtonProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }
  return (
    <PopoverContainer
      onMouseEnter={(e) => {
        if (popover) handlePopoverOpen(e)
      }}
      onMouseLeave={() => {
        if (popover) handlePopoverClose()
      }}
    >
      <StyledButton
        $variant={variant}
        $fullWidth={fullWidth}
        $fullWidthOnMobile={fullWidthOnMobile}
        disabled={variant === ButtonVariant.Disabled || disabled}
        $disabled={variant === ButtonVariant.Disabled || disabled}
        $noBorder={noBorder}
        $height={height}
        $padding={padding}
        $largeIcon={largeIcon}
        $size={size}
        $noBackground={noBackground}
        $hasIcon={!!icon}
        {...rest}
      >
        {popover && (
          <InformationPopover
            anchorEl={anchorEl}
            handlePopoverClose={handlePopoverClose}
            label={popover.label}
          />
        )}
        {leftIcon && (
          <IconContainerStart $size={size}>{leftIcon}</IconContainerStart>
        )}
        {icon ? (
          icon
        ) : (
          <>
            <MobileContainer ellipsis={ellipsis}>
              {!shrinkOnMobile && label}
            </MobileContainer>
            <DesktopContainer ellipsis={ellipsis}>{label}</DesktopContainer>
          </>
        )}
        {rightIcon && (
          <IconContainerEnd $size={size}>{rightIcon}</IconContainerEnd>
        )}
      </StyledButton>
    </PopoverContainer>
  )
}
